






























































import {
  getMemberClientIds,
  getClientsByIds,
  getClientId,
  getMemberClientsConfiguration,
  updateMemberClientsAllDevicesSettings
} from "@/data/repository/ClientRepository";
import { Vue, Component, Ref } from "vue-property-decorator";
import Client, { 
  MemberClientsConfiguration, 
  createDefaultMemberClientsConfiguration,
} from "@/data/models/Client";
import router from "@/router/router";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import MultiSelectionPickerComponent from "@/components/common/MultiSelectionPicker.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { COLOR_BUTTON_SETTINGS_SAVE, COLOR_BUTTON_SETTINGS_EDIT } from "@/utils/colors";
import { themedFill, themedFillTextClass } from "@/utils/Theme";

@Component({
  components: {
    picker: PickerDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "multi-selection-picker": MultiSelectionPickerComponent,
  },
})
export default class AllDevicesSettingsAdministrationComponent extends Vue {
  isLoading = false;
  isIntiallyLoading = true;
  isEditMode = false;

  yesNoValues = [true, false];
  memberClients = new Map<string, Client>();

  memberClientsConfiguration: MemberClientsConfiguration = createDefaultMemberClientsConfiguration();
  initialDevicesSettingsSettingsAdministration = this.getAllDevicesSettingsAdministration();

  selectableClients = this.memberClientIds;

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  get buttonColor() {
    return themedFill(this.isEditMode
      ? COLOR_BUTTON_SETTINGS_SAVE
      : COLOR_BUTTON_SETTINGS_EDIT);
  }

  get buttonTextClass() {
    return themedFillTextClass(this.isEditMode
      ? COLOR_BUTTON_SETTINGS_SAVE
      : COLOR_BUTTON_SETTINGS_EDIT, "white--text");
  }
  
  get hasChanged() {
    return (
      this.memberClientsConfiguration.defineOwnAllDevicesSettings !== this.initialDevicesSettingsSettingsAdministration.defineOwnAllDevicesSettings ||
      this.memberClientsConfiguration.memberClientsWithOwnAllDevicesSettings !== this.initialDevicesSettingsSettingsAdministration.memberClientsWithOwnAllDevicesSettings
    );
  }

  get readonly() {
    return !this.isEditMode;
  }

  get memberClientIds() {
    return getMemberClientIds().filter(id => id !== getClientId());
  }

  get showMemberClientsSelector() {
    return this.memberClientsConfiguration.defineOwnAllDevicesSettings;
  }

  getAllDevicesSettingsAdministration() {
    return {
      defineOwnAllDevicesSettings: this.memberClientsConfiguration?.defineOwnAllDevicesSettings,
      memberClientsWithOwnAllDevicesSettings: this.memberClientsConfiguration?.memberClientsWithOwnAllDevicesSettings
    };
  }

  get formatYesNo() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "yes" : "no"}`).toString();
    };
  }

  get selectableClientsFormatter() {
    return (memberClientId: string) => {
      const client = this.memberClients.get(memberClientId);

      if (!client) {
        return null;
      }

      const clientName =
        !client.companyName || client.companyName === ""
          ? client.clientName
          : client.companyName;

      return clientName;
    };
  }

  async created() {
    this.isIntiallyLoading = true;
    this.memberClients = await getClientsByIds(this.memberClientIds);
    const activeMemberClientIds = Array.from(this.memberClients.keys());

    this.memberClientsConfiguration = getMemberClientsConfiguration(activeMemberClientIds);
    this.initialDevicesSettingsSettingsAdministration = this.getAllDevicesSettingsAdministration();
    this.isEditMode = false;

    this.isIntiallyLoading = false;
  }

  async onSave() {
    if (!this.isEditMode) {
      this.isEditMode = true;
      return;
    }

    if (!this.hasChanged) {
      return;
    }

    this.isLoading = true;
    const result = await updateMemberClientsAllDevicesSettings(this.memberClientIds, this.memberClientsConfiguration);

    this.isLoading = false;
    if (result) {
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      
      this.initialDevicesSettingsSettingsAdministration = this.getAllDevicesSettingsAdministration();
      this.isEditMode = false;
    }
  }

  async onBack() {
    if (this.isEditMode) {
      if (this.hasChanged) {
        const result = await this.confirmationDialogComponent.show({
          title: this.$t("common.confirmationDialog.cancelTitle").toString(),
          message: this.$t("common.confirmationDialog.cancelMessage").toString(),
        });

        if (result) {
          this.memberClientsConfiguration.defineOwnAllDevicesSettings = this.initialDevicesSettingsSettingsAdministration.defineOwnAllDevicesSettings;
          this.memberClientsConfiguration.memberClientsWithOwnAllDevicesSettings = this.initialDevicesSettingsSettingsAdministration.memberClientsWithOwnAllDevicesSettings;
          this.isEditMode = false;
          return;
        }

        return;
      }

      this.isEditMode = false;
      return;
    }

    router.back();
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.administration.allDevicesSettings.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
